import { render, staticRenderFns } from "./ValidationReport.vue?vue&type=template&id=5195727e&scoped=true&"
import script from "./ValidationReport.vue?vue&type=script&lang=js&"
export * from "./ValidationReport.vue?vue&type=script&lang=js&"
import style0 from "./ValidationReport.vue?vue&type=style&index=0&id=5195727e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5195727e",
  null
  
)

export default component.exports